
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/peri-perks",
      function () {
        return require("private-next-pages/peri-perks/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/peri-perks"])
      });
    }
  